import React from "react";
import { BrowserRouter as Router, Switch, Route} from "react-router-dom";
import {} from "react-router";
import "./App.css";
import Login from "./components/newLogin.jsx";
import Signup from "./components/newSignup.jsx";
import Main from "./components/Main";

function App() {
  return (
    <Router>
      <Switch>
        <Route exact path="/">
          {/* <Link to="/login">signup</Link> */}
          {/* <br /> */}
          <Main />
        </Route>
        <Route path="/login">
          <Login />
        </Route>
        <Route path="/signup">
          <Signup />
        </Route>
      </Switch>
    </Router>
  );
}

export default App;
